import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'

const ToggleButton = ({ children, on, ...props }) => {
  return (
    <Button
      style={{
        backgroundColor: on
          ? 'rgba(255, 255, 255, 0.1)'
          : 'transparent'
      }}
      {...props}>
      {children}
    </Button>
  )
}

ToggleButton.propTypes = {
  on: PropTypes.bool
}

export default ToggleButton
